import React from "react";
import "./Header.css";
import logo from "../assets/logo.webp";

export default function Header() {
  return (
    <header className="site-header">
      <div className="container header-container">
        <div className="branding">
          <a href="https://cc-wohnwerte.de" className="logo-placeholder">
            <img src={logo} alt="C&C Wohnwerte Logo" className="site-logo" />
          </a>
          <div className="branding-text">
            <h1 className="site-title">C&amp;C Wohnwerte</h1>
            <p className="site-claim">Ehrlich. Engagiert. Echt.</p>
          </div>
        </div>
      </div>
    </header>
  );
}
